import React from 'react';
import { BellIcon, CameraIcon, CheckIcon, ChevronRightIcon, GiftIcon, ListChecksIcon, ShieldCheckIcon } from 'lucide-react';
import { StatusBar } from '../phone/StatusBar';
import { TabBar } from '../phone/TabBar';
const entries = [{
  icon: ListChecksIcon,
  title: 'Home & Living Fair',
  meta: 'Quiz',
  status: 'In the draw'
}, {
  icon: CameraIcon,
  title: 'Summer Festival',
  meta: 'Photo mission',
  status: 'In review'
}];
export function DashboardScreen() {
  return <div className="flex h-full flex-col" data-id="element-278" data-mp="5d6d71t1xu5s">
      <StatusBar data-id="element-279" data-mp="5c506rsh6xlf" />
      <div className="px-4 pt-5" data-id="element-280" data-mp="5cn5edx48m5h">
        <div className="flex items-center justify-between" data-id="element-281" data-mp="k22ulph00jj2">
          <div data-id="element-282" data-mp="k1jfegiqg98q">
            <p className="text-[10px] font-medium text-muted" data-id="element-283" data-mp="k45ia2uoi0km">Welcome back</p>
            <p className="font-display text-[22px] font-extrabold tracking-tight" data-id="element-284" data-mp="f3htlntx9vtk">My activity</p>
          </div>
          <span className="grid h-9 w-9 place-items-center rounded-full bg-forest text-[10px] font-bold text-mint" data-id="element-285" data-mp="t30q1jddfiq1">
            SV
          </span>
        </div>

        <div className="leaf-md mt-3 bg-forest p-4 text-white" data-id="element-286" data-mp="3ie9b2mifgeo4">
          <div className="flex items-center gap-2" data-id="element-287" data-mp="3met9ruinfqcd">
            <span className="grid h-7 w-7 place-items-center rounded-full bg-mint" data-id="element-288" data-mp="3mfbcn9zth2t9">
              <CheckIcon className="h-4 w-4 text-forest-deep" strokeWidth={3} data-id="element-289" data-mp="3rcundzxb2xgg" />
            </span>
            <p className="font-display text-[14px] font-bold" data-id="element-290" data-mp="8mh114e8e06">You're in the draw</p>
          </div>
          <p className="mt-2 text-[9.5px] leading-snug text-white/70" data-id="element-291" data-mp="55mrdo8a02x3">
            Entry confirmed. The winner is chosen by rules fixed before the action started.
          </p>
        </div>

        <p className="mt-4 text-[10px] font-bold text-muted" data-id="element-292" data-mp="dypzdh05jnkc">Participations</p>
        <div className="mt-1.5 space-y-1.5" data-id="element-293" data-mp="ixt573nyhxtd">
          {entries.map(({
          icon: Icon,
          title,
          meta,
          status
        }) => <div key={title} className="flex items-center gap-2.5 rounded-xl bg-white p-2 ring-1 ring-line" data-id="element-294" data-mp="nxyq80zq0m2h">
              <span className="grid h-7 w-7 place-items-center rounded-lg bg-canvas" data-id="element-295" data-mp="sxbnzgs4rdju">
                <Icon className="h-3.5 w-3.5 text-forest" data-id="element-296" data-mp="37blz0j2nwzv" />
              </span>
              <div className="flex-1" data-id="element-297" data-mp="3ueo3jgnvacgb">
                <p className="text-[10.5px] font-bold" data-id="element-298" data-mp="3ufqsvk5jk6u4">{title}</p>
                <p className="text-[9px] text-muted" data-id="element-299" data-mp="cyg05y0xbdtn">{meta}</p>
              </div>
              <span className="text-[9px] font-semibold text-forest" data-id="element-300" data-mp="877pyzrrroff">{status}</span>
            </div>)}
        </div>

        <p className="mt-3 text-[10px] font-bold text-muted" data-id="element-301" data-mp="lxtbyxcisehj">Prizes won</p>
        <div className="mt-1.5 flex items-center gap-2.5 rounded-xl bg-mint-soft p-2" data-id="element-302" data-mp="gzjf8ib5d5tt">
          <span className="grid h-7 w-7 place-items-center rounded-lg bg-white" data-id="element-303" data-mp="h1vsii5yms0j">
            <GiftIcon className="h-3.5 w-3.5 text-forest" data-id="element-304" data-mp="vw0nh0o1i4c5" />
          </span>
          <p className="flex-1 text-[10.5px] font-bold" data-id="element-305" data-mp="qz0iyu6u99n5">Sponsor prize</p>
          <span className="rounded-full bg-forest px-2.5 py-1 text-[9px] font-bold text-white" data-id="element-306" data-mp="2xndh2tkk4psw">Claim</span>
        </div>

        <div className="mt-3 divide-y divide-line rounded-xl bg-white ring-1 ring-line" data-id="element-307" data-mp="2sqdmbet5r9h3">
          {[{
          icon: BellIcon,
          label: 'Notifications'
        }, {
          icon: ShieldCheckIcon,
          label: 'Privacy center'
        }].map(({
          icon: Icon,
          label
        }) => <div key={label} className="flex items-center gap-2.5 px-2.5 py-2" data-id="element-308" data-mp="yhqa15ls8hxn">
              <Icon className="h-3.5 w-3.5 text-forest" data-id="element-309" data-mp="13gb9v3x4gzlk" />
              <span className="flex-1 text-[10.5px] font-semibold" data-id="element-310" data-mp="13eqifn63twrx">{label}</span>
              <ChevronRightIcon className="h-3.5 w-3.5 text-muted" data-id="element-311" data-mp="pfgycces2iio" />
            </div>)}
        </div>
      </div>
      <TabBar active="activity" data-id="element-312" data-mp="tjoome0vw6j0" />
    </div>;
}